import React from "react";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import easy from '../../assets/img/easy-to-use.png'
import verified from '../../assets/img/verified.png'
import savings from '../../assets/img/savings.png'

export const Services = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const services = [
    { title: "Hurtigt og nemt", description: "Find din næste bog på få minutter – hurtigt og enkelt." },
    { title: "Sikker handel", description: "Vi tilbyder en tryg og sikker handel med beskyttelse af begge parter." },
    { title: "Spar penge", description: "Få fat i bøger til en brøkdel af prisen – spar penge hver gang!" },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    centerMode: false // Fjerner ekstra spacing
  };

  return (
    <div className="text-white">
      {isMobile ? (
        // 📱 Mobil: Vis slider
        <Slider {...settings}>
          {services.map((service, i) => (
            <div key={i} className="h-full px-6 py-10 text-center bg-gradient-to-r from-emerald-500 to-emerald-700 bg-size-200 bg-pos-0 select-none space-y-2 content-center">
              <div className="w-14 h-auto mx-auto"><img src={i === 0 ? easy : i === 1 ? verified : savings} className="w-full" /></div>
              <div className="">
                <h3 className="text-xl font-bold">{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      ) : (
        // 💻 Desktop: Vis alle services ved siden af hinanden
        <div className="flex justify-between">
          {services.map((service, i) => (
            <div key={i} className="px-6 py-10 w-1/3 text-center bg-gradient-to-r from-emerald-500 to-emerald-600 bg-size-200 bg-pos-0 select-none space-y-2">
              <div className="w-14 h-auto mx-auto"><img src={i === 0 ? easy : i === 1 ? verified : savings} className="w-full" /></div>
              <div className="">
                <h3 className="text-xl font-bold">{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
